export default __webpack_public_path__ + "static/media/est-vendanova.599a8f50.png";